export const selectFamilyHistory = (state) => state.familyHistory;
export const selectFamilyData = (state) => state.familyHistory.data;
export const selectFamilyLoading = (state) => state.familyHistory.loading;
export const selectFamilyError = (state) => state.familyHistory.error;
